import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Grid,
  Divider,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import * as XLSX from 'xlsx';

const StatItem = ({ label, value, color }) => {
  return (
    <Grid item xs={12} sm={6} md={4}>
      <Box
        sx={{
          p: 2,
          borderRadius: 2,
          backgroundColor: '#f9f9f9',
          boxShadow: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color }}>
          {label}
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {value ?? 0}
        </Typography>
      </Box>
    </Grid>
  );
};

export default function StatsModal({
  activeMembers,
  inactiveMembers,
  newMembers,
  restoredMembers,
  totalMembers,
  membersWithTrainers,
  personalCoachingMembers,
  open,
  setOpen,
}) {
  const handleDownload = () => {
    const stats = [
      ['Active Members', activeMembers ?? 0],
      ['Inactive Members', inactiveMembers ?? 0],
      ['New Members', newMembers ?? 0],
      ['Returning Members', restoredMembers ?? 0],
      ['Personal Coaching Members', personalCoachingMembers ?? 0],
      ['Members with Trainers (Active)', membersWithTrainers ?? 0],
      ['Total Members', totalMembers ?? 0],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet([['Member Statistics', ''], ...stats]);
    worksheet['!cols'] = [{ width: 30 }, { width: 20 }];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Stats');
    XLSX.writeFile(workbook, 'member_stats.xlsx');
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
        },
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.6rem' }}>
        Member Statistics
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={3}>
          <StatItem label="Active Members" value={activeMembers} color="#2E7D32" />
          <StatItem label="Inactive Members" value={inactiveMembers} color="#D32F2F" />
          <StatItem label="New Members" value={newMembers} color="#0288D1" />
          <StatItem label="Returning Members" value={restoredMembers} color="#F9A825" />
          <StatItem
            label="Personal Coaching Members"
            value={personalCoachingMembers}
            color="#1565C0"
          />
          <StatItem
            label="Members with Trainers (Active)"
            value={membersWithTrainers}
            color="#6A1B9A"
          />
          <StatItem label="Total Members" value={totalMembers} color="#424242" />
        </Grid>

        <Divider sx={{ my: 3 }} />

        <Box display="flex" justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            startIcon={<DownloadIcon />}
            onClick={handleDownload}
            sx={{
              borderRadius: 2,
              px: 3,
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Download Stats
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
